type SiteForIndex = { properties?: { name?: string; strata?: string; isRandomSite?: boolean } }

const DIGITS_ONLY = /^\d+$/

/**
 * Los nombres libres de sitios manuales y los nombres aleatorios heredados no deben desplazar
 * la numeración; por eso solo cuentan los aleatorios con nombre `<strataName>-<n>`.
 */
export function getInitialSiteIndex(strataName: string, existingSites: SiteForIndex[]): number {
  const prefix = `${strataName}-`
  const maxNumber = (existingSites || []).reduce((max, site) => {
    const { name, strata, isRandomSite } = site.properties ?? {}
    if (!isRandomSite || strata !== strataName || !name?.startsWith(prefix)) {
      return max
    }
    const suffix = name.slice(prefix.length)
    return DIGITS_ONLY.test(suffix) ? Math.max(max, parseInt(suffix, 10)) : max
  }, 0)

  return maxNumber + 1
}

/**
 * Calcula el índice inicial para una NUEVA aleatorización completa, considerando
 * únicamente sitios ya persistidos (con id de backend). Los sitios aleatorios o
 * manuales aún no guardados se ignoran, de modo que re-aleatorizar un plan no
 * guardado siempre reinicia la numeración desde 1 en lugar de acumularla.
 *
 * @param strataName - Nombre de la strata para filtrar sitios
 * @param sites - Array de sitios de la strata (mezcla de guardados y sin guardar)
 * @returns El índice inicial basado solo en los sitios guardados
 */
export function getInitialSiteIndexFromSavedSites(
  strataName: string,
  sites: Array<{
    properties?: SiteForIndex['properties'] & { id?: string; newManualSite?: boolean }
  }>,
): number {
  const savedSites = (sites || []).filter(
    site => site.properties?.id && !site.properties?.newManualSite,
  )
  return getInitialSiteIndex(strataName, savedSites)
}
